import { render, staticRenderFns } from "./is-oficial.vue?vue&type=template&id=dbbfefde"
import script from "./is-oficial.vue?vue&type=script&lang=js"
export * from "./is-oficial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports